import type { SectionHeaderComponentsInterface } from '~/types/AppData/Theme/SectionHeaderComponentsInterface';

export const getSectionHeaderObject = (
  sectionHeader: SectionHeaderComponentsInterface
) => {
  const obj: Record<string, string | number> = {};

  if (sectionHeader.showBorderTop.value) {
    obj.borderTopColor = sectionHeader.borderTopColor.value;
    obj.borderTopWidth = sectionHeader.borderTopWidth.value;
  }

  return obj;
};
